export enum DisputeAlertDecision {
  AutoResolved = "auto_resolved",
  ManualReview = "manual_review",
}
